import "./DashboardDesktopViewComponent.scss";
import template from "./DashboardDesktopViewComponent.html";
import {IAngularEvent, IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {DashboardLayout, DashboardSummaries, DashboardSummary} from "../../models/DashboardViewConfiguration";
import {DashboardViewStore} from "../../store/DashboardViewStore";
import {AddDashboardService} from "../../dialog/add-dashboard/service/AddDashboardService";
import {StateService} from "@uirouter/core";

export const DesktopView = "tfOmsDashboardDesktopView";

export function desktopView(): IComponentOptions {
    return {
        template,
        bindings: {
            activeTab: "<"
        },
        controllerAs: "ctrl",
        controller: DashboardDesktopViewComponentController
    };
}

export class DashboardDesktopViewComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set activeTab(tab: number | null) {
        if (tab != null) {
            this.selectDashboard(tab);
        }
    }

    public editActive = false;
    public selectedTab = 1;

    public readonly dashboards$: Observable<DashboardSummaries>;
    public readonly layoutType$: Observable<DashboardLayout>;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly dashboardViewStore: DashboardViewStore,
                       private readonly addDashboardService: AddDashboardService,
                       private readonly $state: StateService,
                       private readonly confirmationService: ConfirmationService) {
        this.dashboards$ = this.buildDashboards();
        this.layoutType$ = this.buildLayoutType();
    }

    private buildDashboards(): Observable<DashboardSummaries> {
        return this.dashboardViewStore
                   .dashboards
                   .takeUntil(this.destroyed$)
                   .publishReplay(1)
                   .refCount();
    }

    private buildLayoutType(): Observable<DashboardLayout> {
        return this.dashboardViewStore
                   .currentDashboard
                   .map((d) => d.layout)
                   .takeUntil(this.destroyed$)
                   .distinctUntilChanged()
                   .map((l) => l.type)
                   .publishReplay(1)
                   .refCount();
    }

    public $onInit() {
        this.watchDashboardNumberChange();
        this.watchForUnavailableDashboard();
    }

    /*
     * This is for when we create a new Dashboard and select it, otherwise it does nothing
     * as we are already on that route
     */
    private watchDashboardNumberChange() {
        this.dashboardViewStore
            .currentDashboardNumber
            .takeUntil(this.destroyed$)
            .subscribe((dashboard) => {
                this.$state.go(".", {view: dashboard});
            });
    }

    /* If we delete a dashboard or are now otherwise on the incorrect dashboard number then we select the last available */
    private watchForUnavailableDashboard() {
        const source$ = Observable.combineLatest(this.dashboardViewStore.currentDashboardNumber,
                                                 this.dashboardViewStore.dashboards);

        source$.filter(([current, dashboards]) => current > dashboards.length)
               .map(([_, dashboards]) => dashboards.length)
               .subscribe((select) => this.selectDashboard(select));
    }

    private selectDashboard(tab: number) {
        this.dashboardViewStore.select(tab);
        this.selectedTab = tab;
    }

    public summaryTrackBy(summary: DashboardSummary): string {
        return summary.order + summary.name;
    }

    public async openAddDashboard() {
        try {
            const dashboard = await this.addDashboardService.open();
            this.dashboardViewStore.addDashboard(dashboard);
        } catch (e) {

        }
    }

    public async removeDashboard($event: IAngularEvent, dashboard: number) {
        $event.preventDefault();
        if ($event.stopPropagation != null) {
            $event.stopPropagation();
        }
        try {
            await this.confirmationService.confirm("deleteDashboard");
            this.dashboardViewStore.removeDashboard(dashboard);
        } catch (e) {

        }
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
